import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button, FormControlLabel,
  TextField,
  Table, TableBody, TableCell, TableRow, Typography,
} from '@material-ui/core';
import { NavigateNext } from '@material-ui/icons';
import {
  setSendExternalConfig,
  setSendExternalTargetName,
  setSendExternalPopFlg,
  createExternalFile,
  setSendExternalResultPopFlg,
  setErrMsgExternalTargetName,
  getExternalInfo,
  setExternalMaxCheckCount,
  setExternalErrMsg,
} from '../../actions/TargetAction';
import { setSystemLodingFLg } from '../../actions/CommonAction';
import {
  DOWNLOAD_VALUE,
  SEND_TYPE,
} from '../../../common/const';
import styles from './TargetPopSendExternalComponent.module.css';
import CustomRadio from '../common/CustomRadio';
import validator from '../../../common/validator';
import { getMessage } from '../../../common/util';
import { ERROR, INFO } from '../../../common/message';
/**
   * 外部送信確認POPUP
   */
class TargetPopSendExternalComponent extends Component {
  componentDidMount() {
    const { setSendExternalConfigAct } = this.props;
    setSendExternalConfigAct(DOWNLOAD_VALUE.ALL);
  }

  componentDidUpdate(preProps) {
    const {
      sendExternalPopFlg,
      setSendExternalConfigAct,
      setSendExternalTargetNameAct,
      setErrMsgExternalTargetNameAct,
      getExternalInfoAct,
      setSystemLodingFLgAct,
      setExternalMaxCheckCountAct,
      companySearchList,
      setSendExternalResultPopFlgAct,
      setExternalErrMsgAct,
    } = this.props;
    if (preProps.sendExternalPopFlg !== sendExternalPopFlg
      && !sendExternalPopFlg) {
      // Popup表示フラグがfalseに変更された場合
      // ダウンロード対象を初期化
      setSendExternalConfigAct(DOWNLOAD_VALUE.ALL);
      // ターゲットリスト名称初期化
      setSendExternalTargetNameAct('');
      // エラーメッセージ初期化
      setErrMsgExternalTargetNameAct('');
      setExternalErrMsgAct('');
    } else if (preProps.sendExternalPopFlg !== sendExternalPopFlg
      && sendExternalPopFlg) {
      // 外部連携マッピング取得
      const fetchMapping = async () => {
        const mapRes = await getExternalInfoAct();
        if (mapRes) {
          // 上限件数
          setExternalMaxCheckCountAct(mapRes.max_check_count);

          // 上限件数チェック
          // (チェック無の場合はmax_check_count=-1)
          if (mapRes.max_check_count
            && mapRes.max_check_count >= 0
            && companySearchList
            && companySearchList.all_count > mapRes.max_check_count) {
            // 上限超過メッセージ表示
            setSendExternalResultPopFlgAct(false, true);
          }
        }
      };

      setSystemLodingFLgAct(true);
      fetchMapping();
      setSystemLodingFLgAct(false);
    }
  }

  /**
   * ターゲット名称入力桁数チェック
   */
  onBlurExternalTargetName = () => {
    const {
      sendExternalTargetName,
      setErrMsgExternalTargetNameAct,
    } = this.props;

    const errMsg = [];
    if (sendExternalTargetName && sendExternalTargetName.length > 0) {
      // 桁数チェック
      validator.checkMaxLength(sendExternalTargetName, 50, errMsg);
      if (errMsg.length !== 0) {
        setErrMsgExternalTargetNameAct(getMessage(ERROR.E08009, errMsg.join(',')));
        return;
      }
    }
    setErrMsgExternalTargetNameAct();
  }

  /**
   * 外部送信データ作成
   */
  onClickSendExternal = async () => {
    const {
      createExternalFileAct,
      setSystemLodingFLgAct,
    } = this.props;
    setSystemLodingFLgAct(true);
    await createExternalFileAct(SEND_TYPE.EXTERNAL);
    setSystemLodingFLgAct(false);
  }

  render() {
    const {
      sendExternalPopFlg,
      setSendExternalPopFlgAct,
      tradeInfoCondition,
      sendExternalTargetName,
      setSendExternalTargetNameAct,
      sendExternalConfig,
      setSendExternalConfigAct,
      companySearchList,
      sendExternalResultPopFlg,
      setSendExternalResultPopFlgAct,
      errMsgExternalTargetName,
      sendExternalLimitOverFlg,
      externalMaxCheckCount,
      externalErrMsg,
    } = this.props;

    if (!sendExternalPopFlg) {
      return null;
    }

    // 全体件数(3桁カンマ区切り)
    const allCount = (companySearchList)
      ? Number(companySearchList.all_count).toLocaleString()
      : 0;
    // MAX件数(3桁カンマ区切り)
    const maxCount = (externalMaxCheckCount)
      ? Number(externalMaxCheckCount).toLocaleString()
      : 0;

    return (
      sendExternalPopFlg && (
        <div className={`${styles.sendExternalPop}`}>
          {(!sendExternalResultPopFlg
            && !sendExternalLimitOverFlg) && (
              <div className={`${styles.dialog}`}>
                <div className={`${styles.contents}`}>
                  <div className={`${styles.title}`}>外部送信確認</div>
                  <div className={`${styles.errMessage}`}>{externalErrMsg}</div>
                  <div className={`${styles.message}`}>
                    ターゲティング結果
                    {' '}
                    {allCount}
                    件
                    {' '}
                    の外部送信用データを作成します。
                  </div>
                  <Table className={`${styles.formBox}`}>
                    <TableBody>
                      <TableRow>
                        <TableCell className={`${styles.label} ${styles.leftTopRadius}`}>
                          <Typography>
                            ターゲットリスト名称
                            <br />
                            （50文字まで）
                          </Typography>
                        </TableCell>
                        <TableCell className={`${styles.itemCell} ${styles.rightTopRadius}`}>
                          <div className={`${styles.condition}`}>
                            <TextField
                              variant="outlined"
                              margin="normal"
                              value={sendExternalTargetName}
                              onChange={(e) => setSendExternalTargetNameAct(e.target.value)}
                              onBlur={this.onBlurExternalTargetName}
                              error={errMsgExternalTargetName}
                            />
                          </div>
                          <div className={`${styles.errorarea}`}>
                            {errMsgExternalTargetName}
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={`${styles.label} ${styles.leftBottomRadius}`}>
                          <Typography>出力項目レイアウト</Typography>
                        </TableCell>
                        <TableCell className={`${styles.itemCell} ${styles.rightBottomRadius}`}>
                          <div className={`${styles.condition}`}>
                            {/* <div className={`${styles.title}`}>ダウンロードする項目</div> */}
                            <div className={`${styles.row}`}>
                              <div className={`${styles.item}`}>
                                <FormControlLabel
                                  control={<CustomRadio />}
                                  label="全項目"
                                  className={sendExternalConfig === DOWNLOAD_VALUE.ALL
                                    ? styles.radiobuttoncheck : styles.radiobutton}
                                  checked={sendExternalConfig === DOWNLOAD_VALUE.ALL}
                                  onClick={() => setSendExternalConfigAct(DOWNLOAD_VALUE.ALL)}
                                />
                              </div>
                              <div className={`${styles.item}`}>
                                <FormControlLabel
                                  control={<CustomRadio />}
                                  label="カスタムレイアウト"
                                  className={sendExternalConfig === DOWNLOAD_VALUE.MINIMUM
                                    ? styles.radiobuttoncheck : styles.radiobutton}
                                  checked={sendExternalConfig === DOWNLOAD_VALUE.MINIMUM}
                                  onClick={() => setSendExternalConfigAct(DOWNLOAD_VALUE.MINIMUM)}
                                />
                              </div>
                              {!(tradeInfoCondition && tradeInfoCondition.length > 0) && (
                                <div className={`${styles.item}`}>
                                  <FormControlLabel
                                    control={<CustomRadio />}
                                    label="TSR企業情報のみ"
                                    className={sendExternalConfig === DOWNLOAD_VALUE.TSR_ONLY
                                      ? styles.radiobuttoncheck : styles.radiobutton}
                                    checked={sendExternalConfig === DOWNLOAD_VALUE.TSR_ONLY}
                                    onClick={
                                      () => setSendExternalConfigAct(DOWNLOAD_VALUE.TSR_ONLY)
                                    }
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <div className={`${styles.button}`}>
                    <Button
                      variant="contained"
                      className={`${styles.buttoncancel} cancel`}
                      onClick={() => {
                        setSendExternalPopFlgAct(false);
                      }}
                    >
                      キャンセル
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={this.onClickSendExternal}
                      disabled={(errMsgExternalTargetName && errMsgExternalTargetName !== '')}
                    >
                      <NavigateNext className={`${styles.setButtonIcon}`} />
                      決定
                    </Button>
                  </div>
                </div>
              </div>
          )}
            {/* 完了メッセージ */}
          {(sendExternalResultPopFlg
            && !sendExternalLimitOverFlg
          ) && (
            <div className={`${styles.contentsMsg}`}>
              <div className={`${styles.messageCenter}`}>{INFO.I02002}</div>
              <div className={`${styles.buttonCenter}`}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setSendExternalPopFlgAct(false);
                    setSendExternalResultPopFlgAct(false);
                  }}
                >
                  OK
                </Button>
              </div>
            </div>
          )}
          {/* 件数超過メッセージ */}
          {(!sendExternalResultPopFlg
            && sendExternalLimitOverFlg
          ) && (
            <div className={`${styles.contentsMsg}`}>
              <div className={`${styles.limitOverMessage} ${styles.bold}`}>
                現在のターゲティング件数：
                {allCount}
                件
              </div>
              <div className={`${styles.limitOverMessage}`}>
                上限件数を超えています。
                <br />
                {maxCount}
                件以下になるよう検索設定タブで
                <br />
                絞り込み条件を追加してください。
              </div>
              <div className={`${styles.buttonCenter}`}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    setSendExternalPopFlgAct(false);
                    setSendExternalResultPopFlgAct(false, false);
                  }}
                >
                  OK
                </Button>

              </div>
            </div>
          )}
        </div>
      ));
  }
}

export default connect(
  (state) => ({
    externalMaxCheckCount: state.target.externalMaxCheckCount,
    sendExternalConfig: state.target.sendExternalConfig,
    sendExternalTargetName: state.target.sendExternalTargetName,
    tradeInfoCondition: state.target.tradeInfoCondition,
    companySearchList: state.target.companySearchList,
    sendExternalPopFlg: state.target.sendExternalPopFlg,
    sendExternalResultPopFlg: state.target.sendExternalResultPopFlg,
    sendExternalLimitOverFlg: state.target.sendExternalLimitOverFlg,
    errMsgExternalTargetName: state.target.errMsgExternalTargetName,
    externalErrMsg: state.target.externalErrMsg,
  }),
  (dispatch) => ({
    setExternalMaxCheckCountAct: (str) => dispatch(setExternalMaxCheckCount(str)),
    setSendExternalConfigAct: (str) => dispatch(setSendExternalConfig(str)),
    setSendExternalTargetNameAct: (str) => dispatch(setSendExternalTargetName(str)),
    setSendExternalPopFlgAct: (bool) => dispatch(setSendExternalPopFlg(bool)),
    setSendExternalResultPopFlgAct:
    (resultPop, limitOverPop) => dispatch(setSendExternalResultPopFlg(resultPop, limitOverPop)),
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setErrMsgExternalTargetNameAct: (str) => dispatch(setErrMsgExternalTargetName(str)),
    getExternalInfoAct: () => dispatch(getExternalInfo()),
    createExternalFileAct: (str) => dispatch(createExternalFile(str)),
    setExternalErrMsgAct: (str) => dispatch(setExternalErrMsg(str)),
  }),
)(TargetPopSendExternalComponent);
